function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function isElectron() {
  return !("undefined" == typeof window || "object" !== _typeof(window.process) || "renderer" !== window.process.type) || "undefined" != typeof process && "object" === _typeof(process.versions) && process.versions.electron || !!("object" === ("undefined" == typeof navigator ? "undefined" : _typeof(navigator)) && "string" == typeof navigator.userAgent && 0 <= navigator.userAgent.indexOf("Electron"));
}
export default isElectron();